<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="200px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="输入名称" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="类型">
        <el-radio-group v-model="form.type">
          <el-radio :label="0">系统关联</el-radio>
          <el-radio :label="1">操作员关联</el-radio>
          <el-radio :label="2">用户使用</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="状态">
        <el-switch
            v-model="form.status"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="停用">
        </el-switch>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="$router.back()">取 消</el-button>
      <el-button type="success" @click="confirm('form')">确定</el-button>
    </div>
  </d2-container>
</template>
<script>
import {
  addProductCate,
  updateProductCate,
  getProductCateInfo
} from '@/api/merchant/service/product'
import uploadImg from '@/components/uploadImage/index.vue'
import { addUserTag, getUserTagInfo, updateUserTag } from '@/api/demo/user'
export default {
  name: 'editUserTag',
  components: {
    uploadImg
  },
  data () {
    return {
      id: '', // id
      form: {
        type: 0, // 图标
        name: '', // 活动名称
        status: 0 // 状态
      },
      replyOptionLoading: false,
      rules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    let that = this
    that.id = that.$route.query.id
    if (that.id != null) {
      that.getInfo(that.id)
    }
  },
  methods: {
    getInfo (id) {
      let that = this
      getUserTagInfo(id).then(res => {
        that.form = res
      })
    },
    confirm () {
      if (this.id) {
        this.getModify('form')
      } else {
        this.getCreate('form')
      }
    },
    // 新增
    getCreate (forms) {
      let that = this
      that.$refs[forms].validate(valid => {
        addUserTag(that.form).then(res => {
          that.$notify({
            title: '成功',
            message: '新增成功',
            type: 'success',
            duration: 2000
          })
          that.$router.back()
          // that.$router.push("/demo/helper/keyword");
        })
      })
    },
    // 编辑
    getModify (forms) {
      let that = this
      that.$refs[forms].validate(valid => {
        updateUserTag(that.id, that.form).then(res => {
          that.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
            duration: 2000
          })
          that.$router.back()
          // that.$router.push("/demo/helper/keyword");
        })
      })
    }
  },
  mounted () {
  }
}
</script>
<style scoped>
/deep/.el-input-number {
  margin-right: 12px;
}
.footer {
  text-align: center;
  margin-top: 20px;
}
</style>
